<template>
    <v-container>
        <table class="table">
            <thead>
            <tr>
                <th>Nom</th>
                <template v-for="(label, index) in getLabels">
                    <th>{{ label }}</th>
                    <th  v-if="index !== getLabels.length - 1"></th>
                </template>
            </tr>
            </thead>
            <tbody>
            <tr v-for="arrow in selectedTreatment.follows_up_arrows_direction_and_colors.arrows" :key="arrow.name">
                <td>{{ arrow.name }}</td>
                <template v-for="(arrowDetail, index) in arrow.arrows">
                    <td v-if="index !== 0">
                        <v-icon v-if="arrowDetail.direction" :class="arrowDetail.direction" :color="arrowDetail.direction ==='up' ? 'green' : 'warning'">{{ arrowDetail.direction ==="up" ? 'mdi-arrow-up' : 'mdi-arrow-down' }}</v-icon>
                    </td>
                    <td>{{ arrowDetail.score }}</td>
                </template>
            </tr>
            </tbody>
        </table>
    </v-container>
</template>

<script>
import {mapActions, mapState, mapMutations} from 'vuex'
export default {
    name: "EvolutionScoreView",
    created() {
        this.setSelectedMedicalCaseId(this.$route.params.medical_case_id)
        this.setSelectedTreatmentId(this.$route.params.treatment_id)
        this.getTreatmentInfo()
    },
    mounted() {
        if (this.$route.params.locked !== false) {
            this.updateLockedState("true")
            this.setLockedBack(this.$route.params.back);
        }
    },
    computed: {
        ...mapState({
            locked: state => state.locked
        }),
        ...mapState('medical_cases', {
            selectedMedicalCase: state => state.selectedMedicalCase,
        }),
        ...mapState('treatments', {
            selectedTreatment: state => state.selectedTreatment,
        }),
        ...mapState('patients', {
            selectedPatient: state => state.selectedPatient,
        }),
        numberOfColumns() {
            return this.selectedTreatment.follow_ups.filter(follow_up => follow_up.completed).length * 2 + 1
        },

        getLabels(){
            return this.selectedTreatment.follows_up_arrows_direction_and_colors.definitionNames;
        },

    },
    methods: {
        ...mapMutations('medical_cases', [
            'setSelectedMedicalCaseId'
        ]),
        ...mapActions(["validateUnlock"]),
        ...mapActions('treatments', [
            'getTreatmentInfo',
        ]),
        ...mapActions('follow_ups', ['createFollowUp', 'restartFollowUp', 'sendNotification']),
        ...mapMutations('treatments', [
            'setSelectedTreatmentId', 'initForm', 'setShowForm', 'initRevisionForm', 'setShowRevisionForm', 'resetForm'
        ]),
        ...mapMutations('studies', [
            'setSelectedFollowUpDefinitionId'
        ]),
        continueAsSecretary() {
            this.dialog = false
        },
        continueAsPatient() {
            this.dialog = false

            this.updateLockedState("true")
        },
        ...mapMutations(['updateLockedState', "setLockedBack"]),
    },
}
</script>

<style scoped>
.table{
    width: 100%;
    table-layout: fixed;
}
.table th {
    border: 0 dotted #000000;
    border-bottom-width: 1px;
    padding: 5px;
}

.table td {

    text-align: center;
    padding: 5px;
}

.table td:first-child, .table th:first-child {
    text-align: left;
}
.up, .down{
    font-size: 4em;
}
.up{
    rotate: 50deg;
}
.down{
    rotate: 300deg;
}
</style>


